// frontend/modules/in-app-notifications/index.ts
import { ModuleConfig } from '@/core/module';
import { inAppNotificationRoutes } from './routes';
import { useInAppNotificationStore } from './stores/in-app-notification-store';

// Export hooks
export { useInAppNotifications } from './hooks/useInAppNotifications';

// Export components
export { NotificationBell } from './components/NotificationBell';
export { NotificationList } from './components/NotificationList';
export { NotificationItem } from './components/NotificationItem';
export { NotificationDrawer } from './components/NotificationDrawer';

// Export views
export { InAppNotificationListView } from './views/InAppNotificationListView';
export { InAppNotificationDetailView } from './views/InAppNotificationDetailView';

export const InAppNotificationModule: ModuleConfig = {
    name: 'in-app-notifications',
    routes: inAppNotificationRoutes,
    stores: {
        inAppNotification: useInAppNotificationStore
    },
    initialize: () => {
        console.log('In-App Notification module initialized');
    }
};
